// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../../bindings/bao-toolbar2";
function HolidayDateViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.HolidaySchema = parent;
    self.HolidayDatePageIndex = ko.observable(0);
    self.HolidayDatePageIndex.subscribe(function () {
        self.RefreshHolidayDateGrid();
    });
    self.HolidayDatePageSize = ko.observable(10);
    self.HolidayDateTotalRows = ko.observable(0);
    self.HolidayDateSorting = ko.observableArray();
    self.HolidayDateSorting.subscribe(function () {
        self.RefreshHolidayDateGrid();
    });
    self.HolidayDateCollection = ko.observableArray([]);
    var initialized = false;
    self.YearNumbers = ko.observableArray([]);
    self.loadFilter = function () {
        tabPage.IsLoading(true);
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), function (result) {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null)
                    self.YearNumbers.push(result[r].Key);
            }
            self.SelectedYear(JahrAkt);
            tabPage.IsLoading(false);
        });
    };
    self.SelectedYear = ko.observable();
    self.SelectedYear.subscribe(function (item) {
        if (initialized) {
            if (self.HolidayDatePageIndex() != 0) {
                self.HolidayDatePageIndex(0);
            }
            self.RefreshHolidayDateGrid();
        }
    });
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageHolidayDate = Bao.Session.GetMessage("msgDeleteHolidayDate");
    var _creationWizardHolidayMessage = Bao.Session.GetMessage("msgCreationWizardHoliday");
    self.SelectedHolidayDateRow = ko.observable({});
    self.SelectedHolidayDateRow.subscribe(function () {
        self.ToggleHolidayDateToolbarButtons();
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddHolidayDate":
                self.ShowHolidayDateDialog(self.HolidaySchema.HolidaySchemaId(), null);
                break;
            case "EditHolidayDate":
                if (self.SelectedHolidayDateRow() != null) {
                    self.ShowHolidayDateDialog(self.HolidaySchema.HolidaySchemaId(), self.SelectedHolidayDateRow().HolidaySchemaDetailId);
                }
                break;
            case "DeleteHolidayDate":
                if (self.SelectedHolidayDateRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageHolidayDate, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteHolidayDate(self.HolidaySchema.HolidaySchemaId(), self.SelectedHolidayDateRow().HolidaySchemaDetailId);
                        }
                    });
                }
                break;
            case "CreationWizardHolidayDate":
                self.CreationWizardHolidayDate();
                break;
        }
    };
    self.ToggleHolidayDateToolbarButtons = function () {
        ko.utils.arrayForEach(self.HolidayDateToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteHolidayDate" || button.ActionKey() == "EditHolidayDate") {
                button.Enabled(self.SelectedHolidayDateRow() != null);
            }
        });
    };
    self.HolidayDateToolbarButtons = ko.observableArray();
    self.HolidayDateToolbarButtons.subscribe(function () {
        self.ToggleHolidayDateToolbarButtons();
    });
    self.RefreshHolidayDateGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("HolidaySchema/GetHolidayDateCollection", JSON.stringify({
            sessionTabId: self.HolidaySchema.SessionTabId(),
            holidaySchemaId: self.HolidaySchema.HolidaySchemaId(),
            pageIndex: self.HolidayDatePageIndex(),
            pageSize: self.HolidayDatePageSize(),
            sorting: self.HolidayDateSorting(),
            yearFilter: self.SelectedYear()
        }), function (searchResult) {
            self.SelectedHolidayDateRow(null);
            self.HolidayDateTotalRows(0);
            self.HolidayDateCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.HolidayDateCollection(searchResult.Models);
                self.HolidayDateTotalRows(searchResult.TotalRows);
                self.ToggleHolidayDateToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.AddHolidayDate = function (model, holidaySchemaId) {
        tabPage.IsLoading(true);
        return Bao.post("HolidaySchema/AddHolidayDate", JSON.stringify({
            sessionTabId: self.HolidaySchema.SessionTabId(),
            holidayDateModel: ko.map.toJS(model),
            holidaySchemaId: holidaySchemaId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshHolidayDateGrid();
        });
    };
    self.EditHolidayDate = function () {
        self.ShowHolidayDateDialog(self.HolidaySchema.HolidaySchemaId(), self.SelectedHolidayDateRow().HolidaySchemaDetailId);
    };
    self.DeleteHolidayDate = function (holidaySchemaId, holidaySchemaDetailId) {
        tabPage.IsLoading(true);
        return Bao.post("HolidaySchema/DeleteHolidayDate", JSON.stringify({
            sessionTabId: self.HolidaySchema.SessionTabId(),
            holidaySchemaId: holidaySchemaId,
            holidaySchemaDetailId: holidaySchemaDetailId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshHolidayDateGrid();
        });
    };
    self.CreationWizardHolidayDate = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _creationWizardHolidayMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                return Bao.post("HolidaySchema/CreationWizardHolidayDate", JSON.stringify({
                    sessionTabId: self.HolidaySchema.SessionTabId(),
                    holidaySchemaId: self.HolidaySchema.HolidaySchemaId(),
                    filterYear: self.SelectedYear()
                }), function () {
                    parent.TabPage.DirtyFlag(true);
                    self.RefreshHolidayDateGrid(self.FilterYear);
                });
            }
        });
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("600px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                if (self.Dialog.ViewModel().CompleteCheck() == true) {
                    self.AddHolidayDate(self.Dialog.ViewModel(), self.HolidaySchema.HolidaySchemaId());
                    self.Dialog.Close();
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ViewModel = ko.observable();
    self.ShowHolidayDateDialog = function (holidaySchemaId, holidaySchemaDetailId) {
        Bao.post("HolidaySchema/ShowHolidayDateDialog", JSON.stringify({
            sessionTabId: self.HolidaySchema.SessionTabId(),
            holidaySchemaId: holidaySchemaId,
            holidaySchemaDetailId: holidaySchemaDetailId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().CompleteCheck = function () {
                var isComplete = true;
                if (self.Dialog.ViewModel().Name() == null) {
                    isComplete = false;
                }
                if (self.Dialog.ViewModel().HolidayDateFormat() == null) {
                    isComplete = false;
                }
                if (isComplete == false) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
                return isComplete;
            };
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("HolidaySchema/ResetHolidayDate", JSON.stringify({
            sessionTabId: self.SessionTabId
        }), function () {
            self.RefreshHolidayDateGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.loadFilter().then(function () {
            self.Refresh().then(function () {
                initialized = true;
                def.resolve();
            });
        });
        return def.promise();
    };
}
export default HolidayDateViewModel;